import { AdminGuardService } from '../../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';

import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../../servicios/auth.service';
import { UserGuardService } from '../../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../../servicios/guards/multi-user.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
import { getTreeMissingMatchingNodeDefError } from '@angular/cdk/tree';

export interface PeriodicElement {
  COD_GASTO:string;
  COD_DETALLE:string;
  /*
  FECHA_CARGA: string;
  */
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  /*
  OBSERVACIONES: string;
  */
  //IMAGEN: string; //blanqueada jorge
}
var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-detalles-jorge',
  templateUrl: './detalles-jorge.component.html',
  styleUrls: ['./detalles-jorge.component.css']
})
export class DetallesJorgeComponent implements OnInit, DoCheck {
  COD_GASTO:string;
  /*
  COD_DETALLE:string;
  FECHA_CARGA = new   Date;
  */
  fecha_hoy;
  COD_GASTO_PAGAR;
  FECHA_CARGA_PAGAR; //TRAIDA DEL LOCALST
  DETALLE_PAGAR: string;
  TOTAL_PAGAR: string;
  CATEGORIA_PAGAR: string;
  
  result;
  @ViewChild('TABLE') table: ElementRef;
  displayedColumns: string[] = ['select','COD_GASTO','COD_DETALLE',/*'FECHA_CARGA',*/'FECHA_TICKET', 'DETALLE', 'IMPORTE', 'CATEGORIA'/*, 'OBSERVACIONES' */,'IMAGEN'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  selection = new SelectionModel<PeriodicElement>(true, []);
  selectedDate;
  fotito;
  loading;


  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    //snackbar 2
    public snackBar: MatSnackBar,
    private router: Router
){ 
this.loading=true;
}


error = false;
errorpago = false;

habilitaBotonFinalizarPago(){
  this.error =false;
  this.errorpago = false;
  console.log("sist" + this.COD_PAGO + this.ultimoPago);
  if ((!this.COD_PAGO) || (!this.COD_CHEQUE) || (!this.COD_BANCO)){
    this.error=true;
  }else{
    this.error=false;
  }
  if ((this.COD_PAGO == this.ultimoPago)){
    this.errorpago=true;
  }else{
    this.errorpago=false;
  }
  console.log(this.error + "-" + this.errorpago);
}

ultimoPago;

getUltimoNroPago(){
  console.log("buscando el ultimo nro pago");
  //http://localhost:1337/api/getultimopago/ult
  this.http.get(`${environment.backendUrl}/api/getultimopago/ult`)
    .subscribe((data: any) => {
      this.ultimoPago = data["ULTIMO"];
      if (!this.ultimoPago){
        this.ultimoPago =  '0';
      }
  });

}

llamarNuevaTab(){
  document.getElementById("botonNewTab").click(); 
}

ngDoCheck(){
  this.habilitaBotonFinalizarPago();
}

transformDate(date) {
//this.datePipe.transform(this.FECHA_CARGA, 'yyyy-MM-dd'); //whatever format you need. 
}

codi_detalle_edit;
selectRow(row) {
  this.codi_detalle_edit=row;
  console.log(this.codi_detalle_edit);
  this.getImage();
}
imgObtenida;
getImage(){
  //http://localhost:1337/api/getimage/get?coddet=294
  this.loading=true;
  this.http.get(`${environment.backendUrl}/api/getimage/get?coddet=${this.codi_detalle_edit}`)
  .subscribe((data: any[]) => {
    this.imgObtenida = data["IMAGEN"];
    console.log("imggeteada..");
    console.log(this.imgObtenida);
    this.loading=false;
  });
}

applyFilter(filterValue: string) {
  this.dataSource.filter = filterValue.trim().toLowerCase();
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();  
  }
}

//Si el número de elementos seleccionados coincide con el número total de filas..
isAllSelected() {
const numSelected = this.selection.selected.length;
const numRows = this.dataSource.data.length;
return numSelected === numRows;
}

//Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
masterToggle() {
this.isAllSelected() ?
this.selection.clear() :
this.dataSource.data.forEach(row => this.selection.select(row));
}

addEvent(input: string, $event) {
this.selectedDate = moment($event.value).format('YY-MM-DD');
}

role;
idsec;
estgas;
ngOnInit() {
  window.scroll(0,0);
  this.estgas=localStorage.getItem("estgas");

  this.idsec=this.idsec=localStorage.getItem('seccional');
  this.role = localStorage.getItem('role');

  this.DETALLE_PAGAR = localStorage.getItem('detallegasto_edit');
  this.TOTAL_PAGAR = localStorage.getItem("imp_gasto");
  this.fecha_hoy= new Date;
  this.fecha_hoy = this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
  this.COD_GASTO_PAGAR=localStorage.getItem('codgasto_edit');
  this.FECHA_CARGA_PAGAR=this.datePipe.transform(localStorage.getItem('fec_edit'),"yyyy-MM-dd");
  console.log("datos traidos del local ngOnInit");
  console.log(this.COD_GASTO_PAGAR);
  console.log(this.FECHA_CARGA_PAGAR);
  console.log(this.DETALLE_PAGAR);
  console.log(this.TOTAL_PAGAR);
  
  
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;

  setTimeout(() => {
    console.log("cargando grid..");
    this.cargaGrid();
  }, 1000);

}

cargaGrid(){
  //http://localhost:1337/api/jorgeverdetalles/ver?codgas=48
  this.http.get(`${environment.backendUrl}/api/jorgeverdetalles/ver?codgas=${this.COD_GASTO_PAGAR}`)
  .subscribe((data: any[]) => {
    this.dataSource.data = data; 
    this.loading=false; 
  });
  console.log("grid cargado..");
}

exportAsExcel() {
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
  
  ws["!margins"]={left:0.7, right:0.7, top:0.75, bottom:0.75, header:0.3, footer:0.3}
  XLSX.utils.encode_col(4) + "1".toUpperCase;

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `GastoCOD-${this.COD_GASTO_PAGAR}_detalle_completo.xlsx`);
}


volver(){
  localStorage.removeItem('codgasto_edit');
  this.COD_GASTO_PAGAR = null;
  console.log("borro el codgasto to_edit");
}

noti;

llenarNoti(){
  if (this.role=='PAGADOR'){
    //http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
    this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
      .subscribe((data: any[]) => {
      this.noti = data[0]["TOT"]; 
      localStorage.setItem('notipend',this.noti);
      console.log(`noti= ${localStorage.getItem('notipend')}`);   
    });
  }else{
  //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
  this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
    .subscribe((data: any[]) => {
    this.noti = data[0]["TOT"]; 
    localStorage.setItem('notipend',this.noti);
    console.log(`noti= ${localStorage.getItem('notipend')}`); 
  });
  }
}

  //DATOS NGMODEL PARA ORDEN PAGO
  COD_PAGO;
  COD_CHEQUE;
  COD_BANCO;
  COD_CONCEPTO;

pagarGasto(){
  this.loading=true;
  this.enviarDatosaPrint();
  this.http.get(`${environment.backendUrl}/api/autorizargasto/autorizar?codgas=${this.COD_GASTO_PAGAR}&est=PAGADO`)
  .subscribe((data: any) => {
    this.result = JSON.stringify(data["affectedRows"]);
    if (this.result==1){
      console.log(`GASTO COD: ${this.COD_GASTO_PAGAR} PAGADO CORRECTAMENTE!`);
      //impacto el gasto en la tabla gastos_web_pagos
      this.impactarPago();
  
    }else{
      console.log(`el COD: ${this.COD_GASTO_PAGAR} no existe en la bd!`)
    }
  });
}

blanquearLocal(){
  this.COD_GASTO_PAGAR=null;
  this.FECHA_CARGA_PAGAR=null;
  this.TOTAL_PAGAR=null;
}

enviarDatosaPrint(){
  //this.COD_GASTO_PAGAR;
localStorage.setItem('print_cod_gasto',this.COD_GASTO_PAGAR);
localStorage.setItem('print_fecha_gasto',this.FECHA_CARGA_PAGAR);
localStorage.setItem('print_cod_pago_orden',this.COD_PAGO);
localStorage.setItem('print_cod_cheque',this.COD_CHEQUE);
localStorage.setItem('print_cod_concepto',this.COD_CONCEPTO);
localStorage.setItem('print_cod_cuenta',this.COD_BANCO);
localStorage.setItem('print_fecha_hoy', this.fecha_hoy);

}

impactarPago(){
  //http://localhost:1337/api/jorgeimpactapago/pagar?codgas=28&codpa=596&fec=2019-01-09&imp=500.00&codche=52348&codcon=418-200&codban=111-400
  this.http.get(`${environment.backendUrl}/api/jorgeimpactapago/pagar?codgas=${this.COD_GASTO_PAGAR}&codpa=${this.COD_PAGO}&fec=${this.fecha_hoy}&imp=${this.TOTAL_PAGAR}&codche=${this.COD_CHEQUE}&codcon=${this.COD_CONCEPTO}&codban=${this.COD_BANCO}`)
  .subscribe((data: any) => {
    this.result = JSON.stringify(data["affectedRows"]);
    if (this.result==1){
      console.log(`GASTO IMPACTADO EN gastos_web_pagos CORRECTAMENTE!`);
      this.cargaGrid();
      this.llenarNoti();
      window.scroll(0,0);
      this.loading=false;
      this.COD_PAGO=null;
      this.COD_CHEQUE=null;
      this.COD_BANCO=null;
      this.COD_CONCEPTO=null;
      // snackbar gasto impactado
      this.snackBar.open(`GASTO [${this.COD_GASTO_PAGAR}] PAGADO correctamente!`, 'Cerrar', {duration: 3000});
      //this.router.navigate(['/print']); 
    
    }else{
      console.log(`el COD: ${this.COD_GASTO_PAGAR} no existe en la bd!`)
    }
  });
}

  imprimirGastos(){
    console.log('orto');
  }

  //rotar imagen a lo mand
  cont=0;
  rotate(){
    this.cont = this.cont + 90;
    var img = document.getElementById("ima");
    img.style.webkitTransform = `${this.cont}deg`;
    img.style.rotate = `${this.cont}deg`;
    img.style.transform = `rotate(${this.cont}deg)`;     
  }
  
  //ver img pantalla completa
  fullscreen(){
    document.getElementById("ima").requestFullscreen();
  }
  
  //$("ima").css("transform", "-webkit-transform: scale(1.2) rotate(30deg) translate(50px);");
  


}
